import { render, staticRenderFns } from "./planForBaseStation.vue?vue&type=template&id=68d5d4d6&scoped=true"
import script from "./planForBaseStation.vue?vue&type=script&lang=js"
export * from "./planForBaseStation.vue?vue&type=script&lang=js"
import style0 from "./planForBaseStation.vue?vue&type=style&index=0&id=68d5d4d6&prod&lang=scss"
import style1 from "./planForBaseStation.vue?vue&type=style&index=1&id=68d5d4d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d5d4d6",
  null
  
)

export default component.exports